import { createQueryKeys } from '@lukemorales/query-key-factory';
import { companyApis } from '../../apis/company/apis';
import type { ICompanyListParams, ICompanyServiceChannel } from '../../apis/company/types';
import type { ICompanyData } from '../../types/company';

export const companyQueries = createQueryKeys('company', {
  list: (params: ICompanyListParams) => ({
    queryKey: [params],
    queryFn: async (): Promise<{ data: ICompanyData[]; total: number }> => {
      const response = await companyApis.companyList(params);
      return response.data;
    },
  }),
  details: (params) => ({
    queryKey: [params.companyId],
    queryFn: async (): Promise<{
      channels: ICompanyServiceChannel[];
      companyDetail: ICompanyData;
      models: any[];
    }> => {
      const response = await companyApis.getCompany({ id: params.companyId });
      return response.data;
    },
  }),
});
